import { shareAxios } from './config'

const CAR_LIST_REQUEST_TIMEOUT = 30000

/**
 * 获取系统配置（侧边栏和车队名称）
 * @returns {Promise}
 */
export const getConfig = () => {
  return shareAxios.get('/frontend-api/getConfig')
}

/**
 * 获取用户信息
 * @returns {Promise}
 */
export const getUserInfo = () => {
  return shareAxios.get('/frontend-api/getme')
}

/**
 * 分页获取 GPT 车队列表
 * @param {object} params - 分页与车队类型
 * @param {number} params.page - 页码
 * @param {number} params.size - 每页数量
 * @param {'plus'|'pro'|'free'} params.carPlanType - 车队类型
 * @returns {Promise}
 */
export const getCarList = ({ page = 1, size = 99, carPlanType = 'plus' } = {}) => {
  return shareAxios.post('/frontend-api/carpage', { page, size, carPlanType }, {
    timeout: CAR_LIST_REQUEST_TIMEOUT
  })
}

/**
 * 获取Grok车队列表
 * @returns {Promise}
 */
export const getGrokCarList = () => {
  return shareAxios.post('/frontend-api/grokCarpage', undefined, {
    timeout: CAR_LIST_REQUEST_TIMEOUT
  })
}

/**
 * 获取Gemini车队列表
 * @returns {Promise}
 */
export const getGeminiCarList = () => {
  return shareAxios.post('/frontend-api/geminiCarpage', undefined, {
    timeout: CAR_LIST_REQUEST_TIMEOUT
  })
}

/**
 * 兑换码兑换
 * @param {string} redemptionCode - 兑换码
 * @returns {Promise}
 */
export const exchange = (redemptionCode) => {
  return shareAxios.post('/frontend-api/exchange', { redemptionCode })
}

/**
 * 获取用户订阅套餐列表
 * @returns {Promise}
 */
export const getUserSubscriptions = () => {
  return shareAxios.post('/frontend-api/getUserSubscriptions')
}

/**
 * 获取兑换记录列表
 * @returns {Promise}
 */
export const getRedemptionList = () => {
  return shareAxios.post('/frontend-api/getRedemptionList')
}

/**
 * 发送邮箱操作验证码
 * @param {string} email - 邮箱
 * @param {string} actions - 操作类型
 * @returns {Promise}
 */
export const sendOpMail = (email, actions) => {
  return shareAxios.post('/frontend-api/sendOpMail', { email, actions })
}

/**
 * 绑定邮箱
 * @param {object} data - 绑定邮箱数据
 * @returns {Promise}
 */
export const bindEmail = (data) => {
  return shareAxios.post('/frontend-api/bindEmail', data)
}

/**
 * 修改密码
 * @param {object} data - 修改密码数据
 * @returns {Promise}
 */
export const changePassword = (data) => {
  return shareAxios.post('/frontend-api/changePassword', data)
}

/**
 * 退出登录
 * @returns {Promise}
 */
export const logout = () => {
  return shareAxios.get('/frontend-api/logout')
}

/**
 * 获取 Codex / ClaudeCode 配额信息
 * @returns {Promise}
 */
export const getVibeCodeQuota = () => {
  return shareAxios.get('/frontend-api/vibe-code/quota')
}

/**
 * 重置 Codex / ClaudeCode API Key
 * @param {string} subtype - 'codex' | 'claudecode'
 * @returns {Promise}
 */
export const resetVibeCodeKey = (subtype = 'codex') => {
  return shareAxios.post('/frontend-api/vibe-code/reset-key', { subtype })
}
